// Matreshka initializer
export default function afterMatreshkaInit() {
  this.nodes = {};
  this.$nodes = {};
}